import { Injectable, signal } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { BreadcrumbItem } from '../components';

/**
 * Optional service for displaying `<da-breadcumb />` component in the main layout.
 *
 * @example
 * // The breadcrumbs will be cleared automatically when the
 * // user navigates away from the component.
 *
 * public ngOnInit() {
 *   this.breadcrumbsService.set([
 *     { label: 'Home', link: '/home' },
 *     { label: 'Some Page' }
 *   ]);
 * }
 *
 * // You may also implement the `<da-breadcumb />` within your component
 * // manually and pass in the breadcrumb data directly.
 */
@Injectable({ providedIn: 'root' })
export class BreadcrumbsService {
  public breadcrumbs = signal<BreadcrumbItem[]>([]);

  constructor(private router: Router) {
    // Listen for navigation start events to clear breadcrumbs automatically.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.clear();
      }
    });
  }

  public set(breadcrumbs: BreadcrumbItem[]): void {
    this.breadcrumbs.set(breadcrumbs);
  }

  public clear(): void {
    this.breadcrumbs.set([]);
  }
}
